import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { TrainingSolutionConfig } from '../../../_types/training';

export async function getTrainingSolutionConfig(signal?: AbortSignal): Promise<TrainingSolutionConfig> {
  const url = `${baseApiUrl()}/admin-solution/v1/solutions/training/config`;

  // Real implementation:
  try {
    const response = await fetcher({
      method: 'GET',
      url,
      options: { signal },
    });
    return response;
  } catch (error: unknown) {
    if (typeof error === 'object' && error !== null && 'errorDetails' in error) {
      throw error as ServerErrorResponse;
    }
    throw error;
  }
}

export default function useTrainingSolutionConfig(
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<TrainingSolutionConfig, ServerErrorResponse>(
    ['trainingSolutionConfig'],
    async ({ signal }): Promise<TrainingSolutionConfig> => {
      try {
        return await getTrainingSolutionConfig(signal);
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      ...options,
      keepPreviousData: true,
    }
  );
}
